import { IconBase } from "./iconBase.js";
import { Fragment, jsx, jsxs } from "@emotion/react/jsx-runtime";
//#region src/browser.tsx
var Browser = ({ type, ...rest }) => /* @__PURE__ */ jsx(IconBase, {
	viewBox: "0 0 24 24",
	...rest,
	children: type === "stroke" ? /* @__PURE__ */ jsxs(Fragment, { children: [/* @__PURE__ */ jsx("path", {
		d: "M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ jsx("path", {
		d: "M14.656 8.73 10.55 9.85a1 1 0 0 0-.701.701l-1.12 4.105a.5.5 0 0 0 .614.614l4.105-1.12a1 1 0 0 0 .701-.701l1.12-4.105a.5.5 0 0 0-.614-.614",
		stroke: "currentColor",
		strokeWidth: "1.5",
		strokeLinejoin: "round"
	})] }) : /* @__PURE__ */ jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25m-1.449 7.6 4.105-1.12a.5.5 0 0 1 .614.614l-1.12 4.105a1 1 0 0 1-.701.701l-4.105 1.12a.5.5 0 0 1-.614-.614l1.12-4.105a1 1 0 0 1 .701-.701",
		fill: "currentColor"
	})
});
//#endregion
export { Browser };
